export default __webpack_public_path__ + "static/media/pen.b89e8ddf.svg";